import React from 'react'
import cx from 'classnames'
import styles from './SummaryWidget.module.scss'

interface Action {
  label: string
  onClick?: () => void
}

interface SummaryWidgetProps {
  title: string
  color?: string
  amount: string | number
  percentageDiff?: number
  actions?: Action[]
}

const SummaryWidget = ({ title, color, amount, percentageDiff, actions = [] }: SummaryWidgetProps) => {
  const percentageClass = cx(styles.percentage, {
    [styles['is-negative']]: percentageDiff !== undefined && percentageDiff < 0,
  })

  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <span className={styles.title}>
          {color && <i style={{ backgroundColor: color }} />}
          {title}
        </span>
      </div>
      <div className={styles.amount}>
        <strong>{amount}</strong>
        {percentageDiff ? (
          <span className={percentageClass}>
            {percentageDiff >= 0 && '+'}
            {percentageDiff}%
          </span>
        ) : null}
      </div>
      {actions.length > 0 && (
        <div className={styles.actions}>
          {actions.map((a, i) => (
            <span key={i}>
              <button
                className={a.onClick !== undefined ? styles['action-activated'] : styles.action}
                onClick={a.onClick}
              >
                {a.label}
              </button>
              {i < actions.length - 1 && ', '}
            </span>
          ))}
        </div>
      )}
    </div>
  )
}

export default SummaryWidget
